module.exports = __webpack_public_path__ + "media/images/icons/icon-drops-35579e2070feda760566574894d8f177.svg";